// extracted by mini-css-extract-plugin
export default {"container":"style_container__LJ3ff","img":"style_img__16shn"};